<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12">
            <div class="row mb-2">
              <div class="col-sm-9 my-auto" v-if="activeBundle.ServiceBundleId">
                <p
                  class="d-inline font-weight-bold"
                >{{activeBundle.ServiceBundleName + ' (' + activeBundle.ServiceBundleDescription + ')'}}}</p>
                <a
                  v-if="editBundleMode && activeBundle.ServiceBundleId"
                  href="#"
                  onclick="return false;"
                  class="pl-1"
                  @click="clearSelection"
                >
                  <!-- <img src="@/assets/img/remove_icon.png" /> -->
                </a>
              </div>
              <div class="col-sm-3 my-auto">
                <i
                  v-if="!disableEdit"
                  class="float-right pointer fas fa-trash fas-lg"
                  @click="$bvModal.show('deleteBundle')"
                ></i>
                <i
                  class="float-right pointer pr-2 fas fa-edit fas-lg"
                  v-if="!disableEdit && !editBundleMode"
                  @click="toggleEditBundleMode(true)"
                ></i>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-12 col-sm-6">
                <div class="row">
                  <div class="col-md-4">
                    <p class="font-weight-bold">Effective From:</p>
                  </div>
                  <div class="col-md-8">
                    <el-date-picker
                      v-if="editBundleMode"
                      v-model="activeBundle.EffectiveFrom"
                      :picker-options="{disabledDate}"
                      format="dd MMMM yyyy"
                    />
                    <p v-else>{{activeBundle.EffectiveFrom | moment('Do MMMM YYYY')}}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="row">
                  <div class="col-md-4">
                    <p class="font-weight-bold">Effective To:</p>
                  </div>
                  <div class="col-md-8">
                    <p
                      v-if="activeBundle.hasOwnProperty('EffectiveTo')"
                    >{{activeBundle.EffectiveTo | moment('Do MMMM YYYY')}}</p>
                    <p v-else>Present</p>
                  </div>
                </div>
              </div>
            </div>
            <hr v-if="!editBundleMode" />
            <div v-if="editBundleMode">
              <div class="row">
                <div class="col-12">
                  <div>
                    <div class="text-left float-right">
                      <b-btn
                        @click="toggleEditBundleMode(false)"
                        :disabled="submitStatus == 'PENDING'"
                        class="btn btn-hc mr-1"
                      >Cancel</b-btn>
                      <b-btn
                        @click="saveBundleChanges()"
                        :disabled="submitStatus == 'PENDING'"
                        class="btn btn-hc ml-1"
                      >
                        Save
                        Changes
                      </b-btn>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="mt-4" />
            </div>
            <div class="row" v-if="products && bundlePrices">
              <div class="col-12">
                <b-tabs nav-class="nav nav-tabs nav-fill" content-class="mt-3" fill>
                  <b-tab :disabled="!product('Gas')" title="Gas">
                    <div v-if="product('Gas')" class="container-fluid">
                      <div class="row">
                        <div class="col-lg-6">
                          <p class="mb--20 mb-1 text-left">
                            <label
                              for="exampleFormControlTextarea6"
                              class="font-weight-bold"
                            >Select Service:</label>
                          </p>
                          <b-form-select v-model="this.activeService" class="mb-3" required>
                            <option
                              v-for="(service, index) in orderByEffectiveFrom(this.activeContract.Services)"
                              :key="index"
                              :value="service"
                            >{{service.ServiceIdentifier + ' - ' + service.Site.Address.AddressLines[0]}}</option>
                          </b-form-select>
                        </div>
                      </div>
                      <div class="row" v-if="product('Gas')">
                        <div class="col-sm-12">
                          <div class="bg-secondaryL border p-2 W-100">
                            <div class="table-responsive-lg">
                              <b-table
                                striped
                                :items="orderByEffectiveFrom(bundlePrices)"
                                :fields="productFields"
                              >
                                <template
                                  slot="EffectiveFrom"
                                  slot-scope="data"
                                >{{data.item.EffectiveFrom | moment('Do MMMM YYYY')}}</template>

                                <template slot="EffectiveTo" slot-scope="data">
                                  <div
                                    v-if="data.item.EffectiveTo"
                                  >{{data.item.EffectiveTo | moment('Do MMMM YYYY')}}</div>
                                  <div v-else>Present</div>
                                </template>
                                <template slot="Charges" slot-scope="data">
                                  <div
                                    class="d-block"
                                    v-for="(charge, index) in data.item.Charges"
                                    :key="index"
                                  >
                                    <div class="row">
                                      <div class="w-50">
                                        <p class="font-weight-bold d-inline">{{charge.ChargeName}}</p>
                                      </div>
                                      <div class="w-50">
                                        <p class="d-inline">{{charge.ChargeAmount}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </b-table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <!-- Elec tab start -->
                  <b-tab :disabled="!product('Electricity')" title="Electricity">
                    <!-- <b-tab title="Electrcity"> -->
                    <div v-if="product('Electricity')" class="container-fluid">
                      <div class="row">
                        <div class="col-lg-6">
                          <p class="mb--20 mb-1 text-left">
                            <label
                              for="exampleFormControlTextarea6"
                              class="font-weight-bold"
                            >Select Service:</label>
                          </p>
                          <b-form-select v-model="this.activeService" class="mb-3" required>
                            <option
                              v-for="(service, index) in orderByEffectiveFrom(this.activeContract.Services)"
                              :key="index"
                              :value="service"
                            >{{service.ServiceIdentifier + ' - ' + service.Site.Address.AddressLines[0]}}</option>
                          </b-form-select>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-sm-12">
                          <div class="bg-secondaryL border p-2 W-100">
                            <div class="table-responsive-lg pre-scrollable">
                              <b-table
                                responsive
                                striped
                                :items="orderByEffectiveFrom(bundlePrices)"
                                :fields="productFields"
                              >
                                <!-- <b-table responsive striped :fields="productFields"> -->
                                <template
                                  slot="EffectiveFrom"
                                  slot-scope="data"
                                >{{data.item.EffectiveFrom | moment('Do MMMM YYYY')}}</template>

                                <template slot="EffectiveTo" slot-scope="data">
                                  <div
                                    v-if="data.item.EffectiveTo"
                                  >{{data.item.EffectiveTo | moment('Do MMMM YYYY')}}</div>
                                  <div v-else>Present</div>
                                </template>

                                <template slot="Charges" slot-scope="data">
                                  <div
                                    class="d-block"
                                    v-for="(charge, index) in data.item.Charges"
                                    :key="index"
                                  >
                                    <div class="row">
                                      <div class="w-50">
                                        <p class="font-weight-bold d-inline">{{charge.ChargeName}}</p>
                                      </div>
                                      <div class="w-50">
                                        <p class="d-inline">{{charge.ChargeAmount}}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- <div class="d-block">
                                    <div class="row">
                                      <div class="w-50">
                                        <p class="font-weight-bold d-inline">
                                          Standing
                                          Charge:
                                        </p>
                                      </div>
                                      <div class="w-50">
                                        <p class="d-inline">
                                          {{standingCharge(data.item.Charges)}}
                                        </p>
                                      </div>
                                    </div>
                                  </div>-->
                                </template>
                              </b-table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <!-- <b-tab :disabled="!product('Electricity')" title="Electrcity">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-sm-12">
                          <p>Electricity</p>
                        </div>
                      </div>
                    </div>
                  </b-tab>-->
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="deleteBundle">
      <template slot="modal-header" slot-scope="{ close }">
        <div class="container-fluid">
          <div class="row">
            <div class="col-9 my-auto">
              <h5 class="modal-title">Delete Service Bundle</h5>
            </div>
            <div class="col-3 my-auto">
              <div>
                <div>
                  <span>
                    <a class="close">
                      <i
                        class="far fa-times-circle fa-2x"
                        @click="close()"
                        id="closeDeleteServiceBundle"
                        aria-label="Close"
                      ></i>
                    </a>
                  </span>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="default">
        <p class="my-4 text-center">Are you sure you want to delete this service bundle tenure?</p>
      </template>

      <template slot="modal-footer" slot-scope="{ close }">
        <button
          type="submit"
          class="btn btn-hc float-right"
          @click="deleteServiceBundle"
          :disabled="submitStatus == 'PENDING'"
        >Yes</button>
        <button
          type="submit"
          class="btn btn-hc float-right"
          @click="close()"
          :disabled="submitStatus == 'PENDING'"
        >No</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';

import contractsMixin from '@/mixins/contracts/contracts';

export default {
	mixins: [contractsMixin],
	data() {
		return {
			// activeService: elecServices[0],
			submitStatus: null,
			editBundleMode: false,
			productFields: {
				EffectiveFrom: {
					label: 'Effective From',
					class: 'text-left',
					sortable: true,
				},
				EffectiveTo: {
					label: 'Effective To',
					class: 'text-left',
					sortable: true,
				},
				Charges: {
					label: 'Rates',
				},
			},
		};
	},
	created() {
		this.activeService = this.orderByEffectiveFrom(
			this.activeContract.Services
		)[0];
	},
	updated() {
		this.activeService = this.orderByEffectiveFrom(
			this.activeContract.Services
		)[0];
	},
	computed: {
		activeBundle: {
			get() {
				return this.$store.state.contracts.activeBundle;
			},
			set(bundle) {
				this.$store.commit('updateActiveBundle', bundle);
			},
		},
		products() {
			let that = this;
			return this.$_.findWhere(this.$store.state.contracts.serviceBundles, {
				Id: that.activeBundle.ServiceBundleId,
			}).Products;
		},
		bundlePrices() {
			return this.$_.where(this.$store.state.contracts.serviceBundlesPrices, {
				ServiceBundleId: this.activeBundle.ServiceBundleId,
				contractId: this.activeContract.Id,
			});
		},

		disableEdit() {
			return this.activeContract.ContractStatus == 'NotChargeable';
		},

		disableDateChange() {
			return this.activeContract.ServiceBundles.length < 2;
		},
	},
	methods: {
		disabledDate(date) {
			if (this.disableDateChange)
				return !moment(date).isSame(this.activeContract.StartDate, 'd');
			return !moment(date).isBetween(
				this.activeContract.StartDate,
				this.activeContract.EndDate,
				'd',
				'[)'
			);
		},
		orderByEffectiveFrom(collection) {
			return this.$_.sortBy(collection, function(item) {
				return item.EffectiveFrom;
			}).reverse();
		},
		product(serviceType) {
			return this.$_.findWhere(this.products, {
				ServiceTypeId: serviceType,
			});
		},
		unitCharge(charges) {
			return this.$_.findWhere(charges, {
				ChargeName: 'Unit Charges:',
			}).ChargeAmount;
		},
		standingCharge(charges) {
			return this.$_.findWhere(charges, {
				ChargeName: 'Standing Charges:',
			}).ChargeAmount;
		},
		deleteServiceBundle() {
			this.submitStatus = 'PENDING';
			this.$http
				.delete(
					'https://' +
						Vue.config.honeycomb.queenbee.domain +
						'/api/v1/contracts/' +
						this.activeContract.Id +
						'/serviceBundles/' +
						this.activeBundle.Id,
					{
						withCredentials: true,
					}
				)
				.then((response) => {
					this.submitStatus = 'OK';
					this.$snotify.success(`Success! Service bundle tenure deleted.`);
					this.$store.dispatch('getContracts');
					this.$store.commit('updateActiveSection', 'Contract');
					this.$store.commit('updateBreadcrumbItems', ['Contract']);
					this.activeContract = response.data;
					this.activeBundle = null;
					document.getElementById('closeDeleteServiceBundle').click();
				})
				.catch((error) => {
					this.submitStatus = 'ERROR';
					if (error.response) {
						if (error.response.data.MoreInformation.length > 0) {
							error.response.data.MoreInformation.forEach((e) => {
								this.$snotify.error(`${e.Error}`, {
									timeout: 0,
									closeOnClick: true,
								});
							});
						} else {
							this.$snotify.error(`${error.response.data.UserDescription}`, {
								timeout: 0,
								closeOnClick: true,
							});
						}
					} else if (error.request) {
						this.$snotify.error(`No response recieved.`, {
							timeout: 0,
							closeOnClick: true,
						});
					} else {
						this.$snotify.error(`${error.message}`, {
							timeout: 0,
							closeOnClick: true,
						});
					}
				});
		},
		toggleEditBundleMode(bool) {
			if (bool && !this.editBundleMode) {
				this.beforeEditingBundle = Object.assign({}, this.activeBundle);
			}
			if (!bool && this.editBundleMode) {
				Object.assign(this.activeBundle, this.beforeEditingBundle);
			}
			this.editBundleMode = bool;
		},
		saveBundleChanges() {
			this.submitStatus = 'PENDING';
			this.$http
				.put(
					'https://' +
						Vue.config.honeycomb.queenbee.domain +
						'/api/v1/contracts/' +
						this.activeContract.Id +
						'/serviceBundles/' +
						this.activeBundle.Id,
					{
						EffectiveFrom: moment
							.utc(moment(this.activeBundle.EffectiveFrom).format('YYYY-MM-DD'))
							.format(),
						ServiceBundleId: this.activeBundle.ServiceBundleId,
					},
					{
						withCredentials: true,
					}
				)
				.then((response) => {
					this.submitStatus = 'OK';
					this.$snotify.success(`Success! Changes saved.`);
					this.editBundleMode = false;
					this.activeContract = response.data;
					this.activeBundle = response.data.ServiceBundles.filter(
						(bundle) =>
							bundle.EffectiveFrom ==
							moment
								.utc(
									moment(this.activeBundle.EffectiveFrom).format('YYYY-MM-DD')
								)
								.format()
					)[0];
					this.$store.dispatch('getContracts');
				})
				.catch((error) => {
					this.submitStatus = 'ERROR';
					if (error.response) {
						if (error.response.data.MoreInformation.length > 0) {
							error.response.data.MoreInformation.forEach((e) => {
								this.$snotify.error(`${e.Error}`, {
									timeout: 0,
									closeOnClick: true,
								});
							});
						} else {
							this.$snotify.error(`${error.response.data.UserDescription}`, {
								timeout: 0,
								closeOnClick: true,
							});
						}
					} else if (error.request) {
						this.$snotify.error(`No response recieved.`, {
							timeout: 0,
							closeOnClick: true,
						});
					} else {
						this.$snotify.error(`${error.message}`, {
							timeout: 0,
							closeOnClick: true,
						});
					}
				});
		},
	},
};
</script>
